import { forwardRef, HTMLAttributes } from "react";
import { FileText, File, DiscountCheck } from "tabler-icons-react";
import { createStyles, Indicator } from "@mantine/core";

type ShowUsaveHtmlProps = HTMLAttributes<HTMLDivElement>;

interface CustomShowUsaveHtmlProps {
  issignbyall: boolean;
  signscount: number;
}

const useStyles = createStyles((theme) => ({
  margintop: {
  position: "absolute",
  top: -6,
  right: -6,
  zIndex: 2,
}
}));

const ShowUsaveHtml = forwardRef<
  HTMLDivElement,
  ShowUsaveHtmlProps & CustomShowUsaveHtmlProps
>((props, ref) => {
  const { issignbyall, signscount, ...rest } = props;
  const color = issignbyall ? "green" : "gray";


const fileIcon = signscount > 0 ? (
  <span>
    <File size={48} strokeWidth={1} color={color} />
  </span>
) : (
  <span>
    <FileText size={48} strokeWidth={1} color={color} />
  </span>
);

  return (
<div
  ref={ref}
  {...rest}
  style={{
    position: "relative",
    display: "inline-flex",
    width: 48,
    height: 48,
    alignItems: "center",
    justifyContent: "center",
  }}
>
  {signscount > 0 ? (
    <Indicator
      label={signscount}
      size={14}
      offset={14}
      position="top-end"
      styles={{
        indicator: {
          fontSize: "6px",
        },
      }}
    >
      {/* 🔹 Icon-Container (Größe fix!) */}
      <div
        style={{
          position: "relative",
          width: 48,
          height: 48,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* 🔹 Hintergrund */}
        {fileIcon}

        {/* 🔹 Overlay zentriert */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <DiscountCheck size={26} color={'#005e21'} strokeWidth={2.5} />
        </div>
      </div>
    </Indicator>
  ) : (
    fileIcon
  )}
</div>

  );
});

export default ShowUsaveHtml;

